import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M28.696 1.985A19.92 19.92 0 0 0 20 0a19.92 19.92 0 0 0-8.695 1.985L9.565 20l1.74 18.015A19.921 19.921 0 0 0 20 40a19.92 19.92 0 0 0 8.696-1.985L30.435 20l-1.74-18.015Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M11.305 1.985C4.615 5.219 0 12.07 0 20s4.615 14.78 11.305 18.015V1.985Zm17.391 0v36.03C35.386 34.781 40 27.93 40 20S35.386 5.22 28.696 1.985Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "m26.087 12.174-1.167-.583c-.07.14-1.593 3.24-1.842 7.974h-1.773v-7.391L20 10.434l-1.304 1.74v7.391h-1.774c-.248-4.734-1.772-7.834-1.842-7.974l-2.334 1.166c.017.032 1.602 3.26 1.602 8.113v1.304h4.348v7.391h2.608v-7.391h4.348v-1.305c0-2.509.434-4.578.799-5.872.397-1.41.8-2.235.804-2.243l-1.168-.58Z"
}, null, -1), h = [
  n,
  c,
  s
];
function d(r, a) {
  return e(), l("svg", o, [...h]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
